        //スムーズスクロール
        $('a[href^="#"]').click(function () {
            var speed = 1000;
            var headerHeight = 0;
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top - headerHeight;
            $("html, body").animate({
                scrollTop: position
            }, speed, "swing");
            return false;
        });
        //pcでtel無効
        var ua = navigator.userAgent;
        if (ua.indexOf('iPhone') < 0 && ua.indexOf('Android') < 0) {
            $('a[href^="tel:"]').css('cursor', 'default').click(function (event) {
                event.preventDefault();
            });
        }
        $(function () {
            var topBtn = $('.pagefor');
            topBtn.hide();
            $(window).scroll(function () {
                if ($(this).scrollTop() > 100) {
                    topBtn.fadeIn();
                } else {
                    topBtn.fadeOut();
                }
            });
            topBtn.click(function () {
                $('body,html').animate({
                    scrollTop: 0
                }, 500);
                return false;
            });
        });

/*
var startPos = 0,winScrollTop = 0;
$(window).on('scroll',function(){
    winScrollTop = $(this).scrollTop();
    if (winScrollTop >= startPos) {
        if(winScrollTop >= 200){
            $('.site-header').addClass('hide');
        }
    }
    else{
        $('.site-header').removeClass('hide');
    }
    startPos = winScrollTop;
});
*/
jQuery(window).on('scroll', function () {
    if (jQuery('.top_header').height() < jQuery(this).scrollTop()) {
        jQuery('.top_header').addClass('change-color');
    } else {
        jQuery('.top_header').removeClass('change-color');
    }
});
/*
$(function () {
  if($('.slider_1').length){
    $('.slider_1').slick({
        dots:true,
        prevArrow: '<a class="slick-prev" href="#"><i data-icon="ei-arrow-left" data-size="m"></i></a>',
        nextArrow: '<a class="slick-next" href="#"><i data-icon="ei-arrow-right" data-size="m"></i></a>',
        customPaging: function(slick,index) {
            // スライダーのインデックス番号に対応した画像のsrcを取得
            var targetImage = slick.$slides.eq(index).find('img').attr('src');
            // slick-dots > li　の中に上記で取得した画像を設定
            return '<img src=" ' + targetImage + ' "/>';
        }
    });
  }
});*/